<template>
  <d-button
    v-if="visible"
    class="scroll-to-top rounded-circle"
    @click="scrollToTop"
    :style="{
      bottom: '70px',
    }"
    id="tooltip-scroll-top"
  >
    <i class="fas fa-arrow-up" />
    <d-tooltip
      target="tooltip-scroll-top"
      placement="top"
      :delay="{ show: 500, hide: 1000 }"
    >
      {{ $t('shared.scrollToTop.tooltip') }}
    </d-tooltip>
  </d-button>
</template>

<script>
export default {
  name: 'ScrollToTop',
  props: {
    scrollOffset: {
      type: Number,
      default: 300,
    },
  },
  data() {
    return {
      visible: false,
    };
  },
  methods: {
    checkScroll() {
      this.visible = window.scrollY >= this.scrollOffset;
    },
    scrollToTop() {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    },
  },
  created() {
    window.addEventListener('scroll', this.checkScroll);
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.checkScroll);
  },
  mounted() {
    window.addEventListener('scroll', this.checkScroll);
  },
};
</script>

<style scoped>
.scroll-to-top {
  position: fixed;
  right: 1.5rem;
  z-index: 10;
  width: 48px;
  height: 48px;
  padding: 0;
  font-size: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: bottom 0.3s ease;
}
</style>
